"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Axios = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var rxjs_1 = require("rxjs");
/**
 * @package [react3l-axios-observable](https://www.npmjs.com/package/react3l-axios-observable)
 * @namespace Axios
 * @author thanhtunguet <thanhtung.uet@gmail.com>
 * @description Axios class, like axios, but with observable methods
 */
var Axios = /** @class */ (function () {
    /**
     * Class constructor
     *
     * @param axiosInstance - Axios instance
     */
    function Axios(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    Object.defineProperty(Axios.prototype, "interceptors", {
        get: function () {
            return this.axiosInstance.interceptors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axios.prototype, "defaults", {
        get: function () {
            return this.axiosInstance.defaults;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Create a new Axios instance
     * @param config {AxiosRequestConfig}
     */
    Axios.create = function (config) {
        var axiosInstance = axios_1.default.create(config);
        return new Axios(axiosInstance);
    };
    Axios.request = function (config) {
        return Axios.createObservable(axios_1.default.request, config);
    };
    Axios.get = function (url, config) {
        return Axios.createObservable(axios_1.default.get, url, config);
    };
    Axios.delete = function (url, config) {
        return Axios.createObservable(axios_1.default.delete, url, config);
    };
    Axios.head = function (url, config) {
        return Axios.createObservable(axios_1.default.head, url, config);
    };
    Axios.options = function (url, config) {
        return Axios.createObservable(axios_1.default.options, url, config);
    };
    Axios.post = function (url, data, config) {
        return Axios.createObservable(axios_1.default.post, url, data, config);
    };
    Axios.put = function (url, data, config) {
        return Axios.createObservable(axios_1.default.put, url, data, config);
    };
    Axios.patch = function (url, data, config) {
        return Axios.createObservable(axios_1.default.patch, url, data, config);
    };
    /**
     * Create an observable function from a promise function
     *
     * @param promiseFunction
     * @param args
     * @private
     */
    Axios.createObservable = function (promiseFunction) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var config = args[args.length - 1];
        config = typeof config === 'object' ? tslib_1.__assign({}, config) : {};
        args[args.length - 1] = config;
        var cancelSource;
        var hasCancelToken = !!config.cancelToken;
        if (hasCancelToken) {
            console.warn("No need to use cancel token, just unsubscribe the subscription would cancel the http request automatically");
        }
        return new rxjs_1.Observable(function (subscriber) {
            if (!hasCancelToken) {
                cancelSource = axios_1.default.CancelToken.source();
                config.cancelToken = cancelSource.token;
            }
            promiseFunction.apply(void 0, args).then(function (response) {
                subscriber.next(response);
                subscriber.complete();
            })
                .catch(function (error) { return subscriber.error(error); });
        });
    };
    Axios.prototype.request = function (config) {
        return Axios.createObservable(this.axiosInstance.request, config);
    };
    Axios.prototype.get = function (url, config) {
        return Axios.createObservable(this.axiosInstance.get, url, config);
    };
    Axios.prototype.delete = function (url, config) {
        return Axios.createObservable(this.axiosInstance.delete, url, config);
    };
    Axios.prototype.head = function (url, config) {
        return Axios.createObservable(this.axiosInstance.head, url, config);
    };
    Axios.prototype.options = function (url, config) {
        return Axios.createObservable(this.axiosInstance.options, url, config);
    };
    Axios.prototype.post = function (url, data, config) {
        return Axios.createObservable(this.axiosInstance.post, url, data, config);
    };
    Axios.prototype.put = function (url, data, config) {
        return Axios.createObservable(this.axiosInstance.put, url, data, config);
    };
    Axios.prototype.patch = function (url, data, config) {
        return Axios.createObservable(this.axiosInstance.patch, url, data, config);
    };
    /**
     * Axios default config
     *
     * @type {AxiosRequestConfig}
     */
    Axios.defaults = axios_1.default.defaults;
    /**
     * Axios interceptor manager
     *
     * @type {AxiosInstance['interceptor']}
     */
    Axios.interceptors = axios_1.default.interceptors;
    return Axios;
}());
exports.Axios = Axios;
//# sourceMappingURL=Axios.js.map